// extracted by mini-css-extract-plugin
export default {"select-all":"_1lmFWHblWH","selectAll":"_1lmFWHblWH","group":"_3-uBkbZjAk","right-label":"_3dz57rE2kI","rightLabel":"_3dz57rE2kI","grant-type":"VOZXr3BK3P","grantType":"VOZXr3BK3P"};
    if(module.hot) {
      // 1633091727219
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  